export default __webpack_public_path__ + "static/media/Animations_Bar3.bd34d7e0.svg";